import type { DragEvent } from "react";
import { useIntl } from "react-intl";
import { SavePersonCollectionCard } from "@/components/save/SaveCollectionTemplate";
import type { PinGroupLite } from "@/components/save/PinGroupSidebar";
import { AddToPinGroup } from "./AddToPinGroup";

// Person pin card. Mirrors Community's ContactCard: the whole card is clickable
// (opens the profile), draggable onto a sidebar group, and hosts its actions
// inside the row (Verschieben popover + trash). stopPropagation keeps action
// clicks from triggering the card's navigation.
export function PinCard({
  itemId,
  isPerson,
  title,
  sub,
  avatarContent,
  avatarMime,
  groups,
  drag,
  onUnpin,
  onAdd,
  onRemoveGroup,
}: {
  itemId: string;
  isPerson: boolean;
  title: string;
  sub: string;
  avatarContent?: string | null;
  avatarMime?: string | null;
  groups: PinGroupLite[];
  drag: { draggable: boolean; onDragStart: (e: DragEvent) => void; onDragEnd: () => void };
  onUnpin: () => void;
  onAdd: (groupId: string) => Promise<void> | void;
  onRemoveGroup: (groupId: string) => Promise<void> | void;
}) {
  const intl = useIntl();
  return (
    <SavePersonCollectionCard
      id={`save-card-${itemId}`}
      title={title}
      subtitle={sub}
      avatarContent={avatarContent}
      avatarMime={avatarMime}
      draggable={drag.draggable}
      onDragStart={drag.onDragStart}
      onDragEnd={drag.onDragEnd}
      openHref={isPerson ? `/p/${itemId}` : undefined}
      onRemove={onUnpin}
      removeLabel={intl.formatMessage({
        id: "save.pinboardPage.removePin",
        defaultMessage: "Remove pin",
      })}
      actions={
        <AddToPinGroup
          itemId={itemId}
          isPerson={isPerson}
          options={groups}
          onAdd={onAdd}
          onRemoveGroup={onRemoveGroup}
        />
      }
    />
  );
}
